import React from 'react';
import styles from './NotAccess.module.scss';

const NotAccess = () => {
  return (
    <div className={styles.root}>
      <div className={styles.content}>Нет доступа</div>
    </div>
  );
};

export default NotAccess;
